export default {
  appName: 'بادپا',
  appTagline: 'پیشخوان راننده'
}
